import { Box, Button, Icon, IconButton, Tooltip } from "@mui/material";
import { useContext } from "react";
import { SpecificColors } from "../../constants/ColorConstants";
import { DialogContext } from "../../contexts/DialogContext";
import TutorialCategoryDialog from "../../features/tutorials/dialogs/TutorialCategoryDialog";

export default function HelpIconButton(props: {
    tag: string;
    variant?: "icon" | "text";
    iconSize?: "medium" | "large";
}) {
    const variant = props.variant ?? "icon";

    const { openDialog } = useContext(DialogContext);

    const openTutorials = () => {
        openDialog(<TutorialCategoryDialog tag={props.tag} />);
    };

    if (variant === "icon") {
        return (
            <Tooltip
                title="راهنما"
                sx={{ color: SpecificColors.Purple2, fontSize: "25px" }}
            >
                <IconButton
                    size="small"
                    color="inherit"
                    onClick={openTutorials}
                >
                    <Icon>help</Icon>
                </IconButton>
            </Tooltip>
        );
    } else {
        return (
            <Box sx={{ color: SpecificColors.Purple2 }}>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={openTutorials}
                    color="inherit"
                    startIcon={<Icon>help</Icon>}
                >
                    راهنما
                </Button>
            </Box>
        );
    }
}
